import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-[#0f0f0f]">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
      {/* Logo above columns */}
      <div className="mb-10">
        <img
          src="https://storage.readdy-site.link/project_files/24cbc93a-97c5-4a4c-8795-e638165a0b41/150f0a6f-f0eb-4598-a9c6-5fbc1a938f2f_black-dog-settlement-services-white.png?v=f6ded5401678ec51453df7ea2bb5dc1a"
          alt="Black Dog Settlement Services"
          className="h-8 sm:h-10 w-auto object-contain max-w-[200px]"
        />
      </div>
      <div className="footer-columns-grid">

        {/* Services */}
        <div>
          <h4 className="text-[#c9a84c] font-bold text-xs uppercase tracking-[0.2em] mb-5">Services</h4>
          <ul className="space-y-2.5">
            {[
              { label: 'Residential Settlements', to: '/services/residential-settlements' },
              { label: 'Commercial Closings', to: '/services/commercial-closings' },
              { label: 'Title Insurance', to: '/services/title-insurance' },
              { label: 'Title Searches', to: '/services/title-searches' },
              { label: '1031 Exchanges', to: '/services/1031-exchanges' },
              { label: 'Refinancing Services', to: '/services/refinancing' },
              { label: 'Deed Preparation', to: '/services/deed-preparation' },
              { label: 'Lien Searches', to: '/services/lien-searches' },
            ].map((s) => (
              <li key={s.to}>
                <Link to={s.to} className="text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer">
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-[#c9a84c] font-bold text-xs uppercase tracking-[0.2em] mb-5">Quick Links</h4>
          <ul className="space-y-2.5">
            {[
              { label: 'Home', to: '/' },
              { label: 'About Us', to: '/about' },
              { label: 'All Services', to: '/services' },
              { label: 'Contact', to: '/contact' },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-[#c9a84c] font-bold text-xs uppercase tracking-[0.2em] mb-5">Contact</h4>
          <div className="space-y-3">
            <a href="tel:2154990796" className="flex items-center gap-3 text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center shrink-0">
                <i className="ri-phone-line text-[#c9a84c]"></i>
              </div>
              215-499-0796
            </a>
            <a href="mailto:info@blackdogsettlement.com" className="flex items-center gap-3 text-white/40 text-sm hover:text-[#c9a84c] transition-colors cursor-pointer break-all">
              <div className="w-4 h-4 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-[#c9a84c]"></i>
              </div>
              info@blackdogsettlement.com
            </a>
            <div className="flex items-start gap-3 text-white/40 text-sm">
              <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-map-pin-line text-[#c9a84c]"></i>
              </div>
              <span>842 Durham Rd, Newtown, PA 18940</span>
            </div>
            <div className="flex items-start gap-3 text-white/40 text-sm">
              <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-time-line text-[#c9a84c]"></i>
              </div>
              <span>Mon–Fri 9AM–5PM &nbsp;|&nbsp; Sat by Appt</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
        <p className="text-xs text-white/25">&copy; {new Date().getFullYear()} Black Dog Settlement. All rights reserved.</p>
        <div className="flex gap-5 text-xs text-white/25">
          <a href="#" className="hover:text-white/50 cursor-pointer whitespace-nowrap">Privacy Policy</a>
          <a href="#" className="hover:text-white/50 cursor-pointer whitespace-nowrap">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
